import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import Fragment from 'vue-fragment'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Fragment.Plugin)
Vue.use(Vuetify)

const opts = {
    icons: {
        iconfont: 'fa'
    }
}

export default new Vuetify(opts)
